/**
 * Created by laugh on 10/15/2017.
 */


export default function (state = "", action) {

    switch (action.type) {
        case 'INIT_PARAMS':
            return action.initParams
        default:
            return state
    }

}


// WEBPACK FOOTER //
// ./src/reducers/init-params.js